// @ts-nocheck
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Box, Grid, Link, Paper, TableCell, TableRow, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { buildStyles, CircularProgressbarWithChildren } from 'react-circular-progressbar'
import { useTranslation } from 'react-i18next'

import CustomTable from '../../../table/CustomTable'

function Submissions({ submissionDetails, allHeadCells, totalSimilarLines }) {
  const { t } = useTranslation()
  const dataParameter = 'id'

  return (
    <>
      <Box pt={1} display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Box display="flex" alignItems="center">
            <Box width="60px" ml={4} className="CircularProgressbar-path-text-outer">
              <CircularProgressbarWithChildren
                value={
                  submissionDetails?.plagiarism?.match_percent
                    ? submissionDetails?.plagiarism?.match_percent
                    : 0
                }
                strokeWidth={10}
                text={
                  submissionDetails?.plagiarism?.match_percent
                    ? `${submissionDetails?.plagiarism?.match_percent?.toFixed(2)}%`
                    : 0
                }
                styles={buildStyles({
                  height: `${1}%`,
                  pathColor: `#007FF4`,
                  textColor: '#000000',
                  textSize: '20px',
                  trailColor: '#d6d6d6',
                })}
              />
            </Box>
          </Box>
          <Box ml={3}>
            <Typography variant="h6" tabIndex={0}>
              <Box component="span" fontWeight="fontWeightBold">
                {t('submissionHeading')} {submissionDetails.submission?.assignment?.title}
              </Box>
            </Typography>
            <Box display="flex" gridGap={10} pt={1}>
              <Typography
                component="span"
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
                style={{
                  background: '#EAF5E6',
                  color: '#248303',
                  padding: '0 5px',
                  borderRadius: '4px',
                }}
              >
                {t('analyzedSentences') + ':'}{' '}
                {submissionDetails?.plagiarism?.sentences || (
                  <Box ml={0.5} className="text-info" component="span" fontWeight={600}>
                    <Box component="span" className="icon-color-light" fontSize="15px">
                      {t('notAvailable')}
                    </Box>
                  </Box>
                )}
              </Typography>
              <Typography
                component="span"
                variant="subtitle1"
                color="textPrimary"
                gutterBottom
                style={{
                  background: '#FAF0E7',
                  color: '#C86307',
                  padding: '0 5px',
                  borderRadius: '4px',
                }}
              >
                {t('foundMatches') + ':'}{' '}
                {totalSimilarLines || (
                  <Box ml={0.5} className="text-info" component="span" fontWeight={600}>
                    <Box component="span" className="icon-color-light" fontSize="15px">
                      {t('notAvailable')}
                    </Box>
                  </Box>
                )}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Grid container spacing={2} justify="space-between" alignItems="flex-start">
        <Grid item xs={12} sm={6}>
          <iframe
            width="100%"
            id="pdfIframe"
            height="500px"
            src={`https://docs.google.com/viewer?url=${encodeURIComponent(
              submissionDetails?.submission?.attachment?.href
            )}&embedded=true`}
            className="easy-frame-height"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper rounded="true" elevation={1} className="paper-round easy-form-height">
            <Box className="cutsom-table-actions">
              <CustomTable
                noDataMessage={t('tableNoRecordFoundMessage')}
                data={submissionDetails?.plagiarism?.similarLines}
                headCells={allHeadCells}
                dataParameter={dataParameter}
                isSelection={false}
              >
                {(submissionDetails?.plagiarism?.similarLines || []).map((row, index) => {
                  return (
                    <TableRow hover data-id={row.line} key={row.line}>
                      <TableCell>
                        <Box width={50}>{index + 1}</Box>
                      </TableCell>
                      <TableCell>
                        <Typography component="p" variant="body2" color="textPrimary" gutterBottom>
                          {row.line}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Link
                          color="primary"
                          className="link-color cursor-pointer"
                          onClick={() => {
                            window.open(row.url)
                          }}
                        >
                          {row.url}
                        </Link>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </CustomTable>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </>
  )
}

Submissions.propTypes = {
  submissionDetails: PropTypes.object,
  allHeadCells: PropTypes.array,
  totalSimilarLines: PropTypes.string,
}

Submissions.defaultProps = {
  submissionDetails: {},
  allHeadCells: [],
  totalSimilarLines: '',
}

export default Submissions
